import React from "react";
import { Link } from "react-router-dom";
import { X, Scale } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function CompareBar() {
  const { compare, toggleCompare, clearCompare } = useApp();
  if (compare.length === 0) return null;

  return (
    <div data-testid="compare-bar" className="fixed bottom-0 inset-x-0 z-40 bg-primary text-primary-foreground shadow-2xl">
      <div className="ec-container py-3 flex items-center gap-4">
        <div className="flex items-center gap-2 shrink-0">
          <Scale className="h-5 w-5 text-accent" aria-hidden />
          <span className="text-sm font-semibold">{compare.length} selected</span>
        </div>
        <div className="flex-1 flex items-center gap-2 overflow-x-auto hide-scrollbar">
          {compare.map((p) => (
            <span key={p.slug} className="flex items-center gap-1.5 bg-white/10 rounded-sm pl-3 pr-1.5 py-1.5 text-xs whitespace-nowrap">
              {p.name}
              <button onClick={() => toggleCompare(p)} aria-label={`Remove ${p.name}`} className="hover:text-accent"><X className="h-3.5 w-3.5" aria-hidden /></button>
            </span>
          ))}
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button onClick={clearCompare} className="text-xs text-primary-foreground/70 hover:text-white px-2">Clear</button>
          <Link to="/compare" data-testid="compare-bar-go" className="inline-flex items-center h-9 px-4 rounded-sm bg-accent text-accent-foreground text-sm font-semibold hover:bg-accent/90 transition-colors">
            Compare
          </Link>
        </div>
      </div>
    </div>
  );
}
